// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=DM+Mono:wght@400;500&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* KinetiQ_UserGuide.css — KinetiQ User Guide
   v5.0 — restyled to match the live KinetiQ product UI (dark navy / teal,
   Inter typeface) instead of the earlier light "Tutorial5" paper theme.
   ============================================================ */

/* ─── Design tokens ─────────────────────────────────────────────── */
:root {
  --ug-bg:              #0a1526;
  --ug-surface:         #101f38;
  --ug-panel:           #14294a;
  --ug-card:            #101f38;
  --ug-code-bg:         #0c1830;
  --ug-eq-bg:           #0c1830;

  --ug-accent:          #17c9a8;
  --ug-accent-dim:      rgba(23, 201, 168, 0.12);
  --ug-accent-glow:     rgba(23, 201, 168, 0.25);
  --ug-accent-hover:    #12a88b;

  --ug-blue:            #5b9dff;
  --ug-blue-dim:        rgba(91, 157, 255, 0.12);
  --ug-blue-border:     rgba(91, 157, 255, 0.30);

  --ug-cyan:            #38bdf8;
  --ug-cyan-dim:        rgba(56, 189, 248, 0.10);
  --ug-cyan-border:     rgba(56, 189, 248, 0.28);

  --ug-amber:           #f5a524;
  --ug-amber-dim:       rgba(245, 165, 36, 0.12);
  --ug-amber-border:    rgba(245, 165, 36, 0.30);

  --ug-red:             #f0453a;
  --ug-red-dim:         rgba(240, 69, 58, 0.12);
  --ug-red-border:      rgba(240, 69, 58, 0.35);

  --ug-green-dim:       rgba(23, 201, 168, 0.08);
  --ug-green-border:    rgba(23, 201, 168, 0.25);

  --ug-border:          #22375c;
  --ug-border-light:    #1a2c4d;
  --ug-border-mid:      #2d4979;

  --ug-text:            #eef3fb;
  --ug-text-muted:      #c1cee3;
  --ug-text-mid:        #a5b4d1;
  --ug-text-dim:        #8194b8;
  --ug-text-sub:        #60729a;

  --ug-font-mono:   'DM Mono', 'JetBrains Mono', monospace;
  --ug-font-ui:     'Inter', 'Segoe UI', system-ui, sans-serif;
  --ug-font-brand:  'Inter', system-ui, sans-serif;
  --ug-font-serif:  'Inter', system-ui, sans-serif; /* kept for compatibility, no longer serif */

  --ug-space-xs:  6px;
  --ug-space-sm:  10px;
  --ug-space-md:  16px;
  --ug-space-lg:  24px;
  --ug-space-xl:  40px;
  --ug-space-2xl: 56px;

  --ug-radius-sm: 5px;
  --ug-radius-md: 9px;
  --ug-radius-lg: 13px;
}

/* ─── Reset ─────────────────────────────────────────────────── */
*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

/* ─── Scrollbar ─────────────────────────────────────────────── */
::-webkit-scrollbar        { width: 5px; height: 5px; }
::-webkit-scrollbar-track  { background: transparent; }
::-webkit-scrollbar-thumb  { background: var(--ug-border-mid); border-radius: 3px; }
::-webkit-scrollbar-thumb:hover { background: var(--ug-text-sub); }

/* ══════════════════════════════════════════════════════════════
   CONTAINER
══════════════════════════════════════════════════════════════ */
.ug-container {
  font-family: var(--ug-font-ui);
  background:  var(--ug-bg);
  color:       var(--ug-text);
  display:     flex;
  height:      100%;
  width:       100%;
  font-size:   15px;
  line-height: 1.7;
  overflow:    hidden;
}

/* ══════════════════════════════════════════════════════════════
   MAIN CONTENT
══════════════════════════════════════════════════════════════ */
.ug-main {
  flex:       1 1;
  overflow-y: auto;
  overflow-x: hidden;
  min-width:  0;
  animation:  fadeInUG 0.3s ease;
}

.ug-main-inner {
  margin:  0 auto;
  padding: 48px 56px 80px;
  max-width: 1100px;
}

/* ─── Hero ──────────────────────────────────────────────────── */
.ug-hero {
  margin-bottom:  var(--ug-space-2xl);
  padding-bottom: 32px;
  border-bottom:  1px solid var(--ug-border-light);
}

.ug-hero-tag {
  font-family:    var(--ug-font-mono);
  font-size:      11px;
  text-transform: uppercase;
  letter-spacing: 3px;
  color:          var(--ug-amber);
  margin-bottom:  12px;
}

.ug-hero h1 {
  font-family:   var(--ug-font-brand);
  font-size:     38px;
  font-weight:   800;
  letter-spacing: -0.5px;
  line-height:   1.2;
  margin-bottom: 12px;
  color:         var(--ug-text);
}

.ug-hero-desc {
  color:       var(--ug-text-muted);
  font-size:   16px;
  max-width:   660px;
  line-height: 1.6;
}

.ug-hero-meta {
  display:    flex;
  gap:        24px;
  margin-top: 20px;
  flex-wrap:  wrap;
}

.ug-meta-item {
  font-family: var(--ug-font-mono);
  font-size:   11px;
  color:       var(--ug-text-dim);
  display:     flex;
  align-items: center;
  gap:         6px;
}

.ug-meta-dot {
  width:         6px;
  height:        6px;
  border-radius: 50%;
  background:    var(--ug-accent);
  display:       inline-block;
}

/* ─── Info table (cover page metadata) ─────────────────────── */
.ug-info-table {
  background:    var(--ug-surface);
  border:        1px solid var(--ug-border-light);
  border-top:    3px solid var(--ug-accent);
  border-radius: var(--ug-radius-lg);
  overflow:      hidden;
  margin-bottom: var(--ug-space-xl);
}

.ug-info-table table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.ug-info-table td {
  padding: 11px 18px;
  border-bottom: 1px solid var(--ug-border-light);
  color: var(--ug-text-muted);
  vertical-align: top;
}

.ug-info-table td:first-child {
  font-family:    var(--ug-font-mono);
  font-size:      11px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  color:          var(--ug-text-dim);
  font-weight:    600;
  width:          180px;
  white-space:    nowrap;
  background:     var(--ug-panel);
}

.ug-info-table tr:last-child td {
  border-bottom: none;
}

.ug-info-table a { color: var(--ug-blue); }

/* ══════════════════════════════════════════════════════════════
   SECTIONS
══════════════════════════════════════════════════════════════ */
.ug-section {
  margin-bottom: var(--ug-space-2xl);
  scroll-margin-top: 24px;
}

.ug-section-label {
  font-family:    var(--ug-font-mono);
  font-size:      10px;
  text-transform: uppercase;
  letter-spacing: 2.5px;
  color:          var(--ug-text-sub);
  margin-bottom:  6px;
}

.ug-section h2 {
  font-family:   var(--ug-font-brand);
  font-size:     25px;
  font-weight:   800;
  letter-spacing: -0.3px;
  color:         var(--ug-text);
  margin-bottom: 6px;
  line-height:   1.3;
}

.ug-section-divider {
  width:         40px;
  height:        3px;
  background:    var(--ug-accent);
  margin-bottom: 22px;
  border-radius: 2px;
}

.ug-section p {
  margin-bottom: 14px;
  color:         var(--ug-text-muted);
  line-height:   1.75;
}

.ug-section strong { color: var(--ug-text); font-weight: 600; }
.ug-section code {
  font-family: var(--ug-font-mono);
  background:  var(--ug-code-bg);
  border:      1px solid var(--ug-border);
  padding:     1px 6px;
  border-radius: 4px;
  font-size:   0.92em;
  color:       var(--ug-cyan);
}

/* ─── Badge / tag ───────────────────────────────────────────── */
.ug-badge {
  display:        inline-block;
  font-family:    var(--ug-font-mono);
  font-size:      10px;
  text-transform: uppercase;
  letter-spacing: 2px;
  padding:        3px 9px;
  border-radius:  var(--ug-radius-sm);
  margin-bottom:  10px;
  font-weight:    500;
}

.ug-badge--green {
  background: var(--ug-green-dim);
  color:      var(--ug-accent);
  border:     1px solid var(--ug-green-border);
}
.ug-badge--amber {
  background: var(--ug-amber-dim);
  color:      var(--ug-amber);
  border:     1px solid var(--ug-amber-border);
}
.ug-badge--blue {
  background: var(--ug-blue-dim);
  color:      var(--ug-blue);
  border:     1px solid var(--ug-blue-border);
}
.ug-badge--cyan {
  background: var(--ug-cyan-dim);
  color:      var(--ug-cyan);
  border:     1px solid var(--ug-cyan-border);
}
.ug-badge--red {
  background: var(--ug-red-dim);
  color:      var(--ug-red);
  border:     1px solid var(--ug-red-border);
}

/* ─── Steps ─────────────────────────────────────────────────── */
.ug-steps {
  display:        flex;
  flex-direction: column;
  gap:            18px;
  margin:         18px 0;
}

.ug-step {
  display:       flex;
  gap:           18px;
  align-items:   flex-start;
  background:    var(--ug-surface);
  border:        1px solid var(--ug-border-light);
  border-radius: var(--ug-radius-md);
  padding:       18px 20px;
  transition:    box-shadow 0.2s, border-color 0.2s;
}

.ug-step:hover {
  box-shadow:  0 2px 14px rgba(0,0,0,0.35);
  border-color: var(--ug-border-mid);
}

.ug-step-number {
  font-family:    var(--ug-font-mono);
  font-size:      13px;
  font-weight:    600;
  color:          #06120e;
  background:     var(--ug-accent);
  width:          32px;
  height:         32px;
  border-radius:  50%;
  display:        flex;
  align-items:    center;
  justify-content:center;
  flex-shrink:    0;
  margin-top:     2px;
}

.ug-step-body {
  flex: 1 1;
  min-width: 0;
}

.ug-step-title {
  font-family:   var(--ug-font-brand);
  font-size:     14.5px;
  font-weight:   700;
  color:         var(--ug-text);
  margin-bottom: 6px;
  line-height:   1.35;
  display:       flex;
  align-items:   center;
  flex-wrap:     wrap;
  gap:           4px;
}

.ug-step-desc {
  font-size:   13.5px;
  color:       var(--ug-text-muted);
  line-height: 1.7;
  margin:      0;
}

.ug-step-red-note {
  display:       inline-flex;
  align-items:   center;
  gap:           5px;
  font-family:   var(--ug-font-mono);
  font-size:     10px;
  text-transform:uppercase;
  letter-spacing:1.5px;
  color:         var(--ug-red);
  background:    var(--ug-red-dim);
  border:        1px solid var(--ug-red-border);
  border-radius: var(--ug-radius-sm);
  padding:       2px 8px;
  margin-left:   8px;
}

/* ─── Callouts ──────────────────────────────────────────────── */
.ug-callout {
  border-radius: var(--ug-radius-md);
  padding:       14px 18px;
  margin:        16px 0;
  font-size:     14px;
  line-height:   1.65;
}
.ug-callout p { color: var(--ug-text-muted); margin: 0; }
.ug-callout strong { color: var(--ug-text); }

.ug-callout--note    { background: var(--ug-blue-dim);  border: 1px solid var(--ug-blue-border);  }
.ug-callout--warning { background: var(--ug-amber-dim); border: 1px solid var(--ug-amber-border); }
.ug-callout--info    { background: var(--ug-cyan-dim);  border: 1px solid var(--ug-cyan-border);  }
.ug-callout--success { background: var(--ug-green-dim); border: 1px solid var(--ug-green-border); }
.ug-callout--danger  { background: var(--ug-red-dim);   border: 1px solid var(--ug-red-border);   }

.ug-callout-icon {
  font-size:     16px;
  margin-right:  6px;
  vertical-align: middle;
}

/* ─── Screenshot placeholder (used only where no real capture exists yet) ── */
.ug-screenshot {
  background:    var(--ug-panel);
  border:        1px dashed var(--ug-border-mid);
  border-radius: var(--ug-radius-md);
  padding:       20px;
  margin:        12px 0;
  text-align:    center;
  color:         var(--ug-text-sub);
  font-family:   var(--ug-font-mono);
  font-size:     11px;
  letter-spacing:1px;
}

.ug-screenshot-icon {
  font-size:     28px;
  display:       block;
  margin-bottom: 6px;
}

/* ─── Product screenshot frame ───────────────────────────────
   Every real screenshot sits in this frame.
   - Images are shown at their ACTUAL pixel size and never stretched
     (width:auto + max-width), so small captures are no longer
     up-scaled to the full column width (that caused the blur / zoomed look).
   - Large captures are shrunk down to a common maximum width so all
     screenshots read at a similar size and text size.
   - Frames are centred and shrink-wrap the image.
   ─────────────────────────────────────────────────────────── */
:root { --ug-shot-max: 760px; }

.ug-shot {
  display:       block;
  width:         fit-content;
  max-width:     min(100%, var(--ug-shot-max));
  margin:        14px auto 4px;
  border-radius: var(--ug-radius-lg);
  overflow:      hidden;
  border:        1px solid var(--ug-border);
  background:    var(--ug-surface);
  box-shadow:    0 6px 20px rgba(0,0,0,0.35);
}

.ug-shot img {
  display:    block;
  width:      auto;        /* natural size - never up-scaled */
  max-width:  100%;        /* large images shrink to the frame */
  height:     auto;
  margin:     0 auto;
  image-rendering: auto;
}

/* Per-figure size presets (use <Shot size="sm|md|lg" /> or <Shot width={px} />) */
.ug-shot--sm { max-width: min(100%, 420px); }
.ug-shot--md { max-width: min(100%, 560px); }
.ug-shot--lg { max-width: min(100%, 760px); }

/* caption strip / red-box dot are no longer used (red boxes removed) */
.ug-shot-note,
.ug-shot-dot { display: none; }

/* ─── Sub-section (5.1, 5.2 style) ─────────────────────────── */
.ug-subsection {
  margin:        24px 0 18px;
}

.ug-subsection h3 {
  font-family:   var(--ug-font-brand);
  font-size:     18px;
  font-weight:   700;
  color:         var(--ug-text);
  margin-bottom: 8px;
  line-height:   1.35;
}

.ug-subsection-divider {
  width:         24px;
  height:        2px;
  background:    var(--ug-blue);
  margin-bottom: 16px;
  border-radius: 2px;
}

/* ─── Reaction formula pill ─────────────────────────────────── */
.ug-reaction {
  display:       inline-block;
  font-family:   var(--ug-font-mono);
  font-size:     13px;
  background:    var(--ug-eq-bg);
  border:        1px solid var(--ug-border);
  border-left:   3px solid var(--ug-amber);
  border-radius: var(--ug-radius-md);
  padding:       8px 16px;
  color:         var(--ug-text-mid);
  margin:        10px 0;
}

/* ─── Contact cards grid ────────────────────────────────────── */
.ug-contact-grid {
  display:               grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap:                   16px;
  margin:                20px 0;
}

.ug-contact-card {
  background:    var(--ug-surface);
  border:        1px solid var(--ug-border);
  border-radius: var(--ug-radius-md);
  padding:       18px;
  transition:    box-shadow 0.2s;
}

.ug-contact-card:hover {
  box-shadow: 0 4px 16px rgba(0,0,0,0.35);
}

.ug-contact-card-icon {
  font-size:     24px;
  margin-bottom: 10px;
  display:       block;
}

.ug-contact-card-title {
  font-family:    var(--ug-font-mono);
  font-size:      10px;
  text-transform: uppercase;
  letter-spacing: 2px;
  color:          var(--ug-accent);
  margin-bottom:  6px;
  font-weight:    600;
}

.ug-contact-card-body {
  font-size:   13px;
  color:       var(--ug-text-muted);
  line-height: 1.6;
}

/* ─── Troubleshooting table ─────────────────────────────────── */
.ug-trouble-table {
  width:           100%;
  border-collapse: collapse;
  margin:          16px 0;
  font-size:       13px;
  background:      var(--ug-surface);
  border-radius:   var(--ug-radius-md);
  overflow:        hidden;
  border:          1px solid var(--ug-border-light);
}

.ug-trouble-table thead {
  background: var(--ug-panel);
}

.ug-trouble-table th {
  padding:        11px 14px;
  text-align:     left;
  font-family:    var(--ug-font-mono);
  font-size:      10px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  color:          var(--ug-text-dim);
  border-bottom:  1px solid var(--ug-border);
  font-weight:    600;
}

.ug-trouble-table td {
  padding:       12px 14px;
  border-bottom: 1px solid var(--ug-border-light);
  color:         var(--ug-text-muted);
  vertical-align: top;
  line-height:   1.6;
}

.ug-trouble-table td:first-child {
  font-weight: 600;
  color:       var(--ug-text);
  white-space: nowrap;
}

.ug-trouble-table tr:last-child td { border-bottom: none; }
.ug-trouble-table tr:hover td { background: var(--ug-accent-dim); }

/* ─── Tutorial cards ────────────────────────────────────────── */
.ug-tutorial-cards {
  display:               grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap:                   18px;
  margin:                20px 0;
}

.ug-tutorial-card {
  background:    var(--ug-surface);
  border:        1px solid var(--ug-border);
  border-radius: var(--ug-radius-md);
  padding:       20px;
  transition:    all 0.2s ease;
}

.ug-tutorial-card:hover {
  transform:  translateY(-3px);
  box-shadow: 0 10px 24px rgba(0,0,0,0.4);
}

.ug-tutorial-card--cre   { border-top: 3px solid var(--ug-accent); }
.ug-tutorial-card--fit   { border-top: 3px solid var(--ug-blue); }
.ug-tutorial-card--react { border-top: 3px solid var(--ug-amber); }

.ug-tutorial-card-title {
  font-family:   var(--ug-font-brand);
  font-size:     15px;
  font-weight:   700;
  color:         var(--ug-text);
  margin-bottom: 8px;
}

.ug-tutorial-card-desc {
  font-size:   13px;
  color:       var(--ug-text-dim);
  line-height: 1.65;
  margin:      0 0 12px;
}

.ug-tutorial-card-tag {
  font-family:    var(--ug-font-mono);
  font-size:      9px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  padding:        2px 8px;
  border-radius:  var(--ug-radius-sm);
  font-weight:    500;
}

/* ─── Platform URL bar ──────────────────────────────────────── */
.ug-url-bar {
  display:       flex;
  align-items:   center;
  gap:           10px;
  background:    var(--ug-eq-bg);
  border:        1px solid var(--ug-border);
  border-radius: var(--ug-radius-md);
  padding:       10px 16px;
  margin:        12px 0;
  font-family:   var(--ug-font-mono);
  font-size:     12px;
  color:         var(--ug-blue);
}

.ug-url-bar a { color: inherit; }

.ug-url-label {
  color:       var(--ug-text-sub);
  font-size:   10px;
  text-transform: uppercase;
  letter-spacing: 1px;
  flex-shrink: 0;
}

/* ─── Bullet list ───────────────────────────────────────────── */
.ug-list {
  list-style:  none;
  padding:     0;
  margin:      12px 0;
}

.ug-list li {
  display:     flex;
  gap:         10px;
  align-items: flex-start;
  font-size:   14px;
  color:       var(--ug-text-muted);
  line-height: 1.7;
  padding:     4px 0;
}

.ug-list li::before {
  content:     '•';
  color:       var(--ug-accent);
  font-size:   18px;
  line-height: 1.3;
  flex-shrink: 0;
}

/* ─── Footer ────────────────────────────────────────────────── */
.ug-footer {
  border-top:  1px solid var(--ug-border-light);
  padding-top: 24px;
  margin-top:  40px;
  color:       var(--ug-text-dim);
  font-family: var(--ug-font-mono);
  font-size:   11px;
  text-align:  center;
}

/* ─── Animation ─────────────────────────────────────────────── */
@keyframes fadeInUG {
  from { opacity: 0; transform: translateY(4px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* ─── Responsive ────────────────────────────────────────────── */
@media (max-width: 1200px) {
  .ug-main-inner { padding: 36px 36px 60px; }
}

@media (max-width: 900px) {
  .ug-main-inner  { padding: 24px 20px 60px; }
  .ug-contact-grid { grid-template-columns: 1fr 1fr; }
}

@media (max-width: 600px) {
  .ug-hero h1          { font-size: 26px; }
  .ug-contact-grid     { grid-template-columns: 1fr; }
  .ug-tutorial-cards   { grid-template-columns: 1fr; }
  .ug-trouble-table td:first-child { white-space: normal; }
  .ug-info-table td:first-child    { width: auto; }
}`, "",{"version":3,"sources":["webpack://./src/styles/UserGuide.css"],"names":[],"mappings":"AAAA;;;iEAGiE;;AAIjE,sEAAsE;AACtE;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;;EAE7B,6BAA6B;EAC7B,8CAA8C;EAC9C,8CAA8C;EAC9C,6BAA6B;;EAE7B,6BAA6B;EAC7B,8CAA8C;EAC9C,8CAA8C;;EAE9C,6BAA6B;EAC7B,8CAA8C;EAC9C,8CAA8C;;EAE9C,6BAA6B;EAC7B,8CAA8C;EAC9C,8CAA8C;;EAE9C,6BAA6B;EAC7B,6CAA6C;EAC7C,6CAA6C;;EAE7C,8CAA8C;EAC9C,8CAA8C;;EAE9C,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;;EAE7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;;EAE7B,wDAAwD;EACxD,4DAA4D;EAC5D,gDAAgD;EAChD,gDAAgD,EAAE,4CAA4C;;EAE9F,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;;EAEpB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,kEAAkE;AAClE;;;EAGE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA,kEAAkE;AAClE,6BAA6B,UAAU,EAAE,WAAW,EAAE;AACtD,6BAA6B,uBAAuB,EAAE;AACtD,6BAA6B,gCAAgC,EAAE,kBAAkB,EAAE;AACnF,kCAAkC,8BAA8B,EAAE;;AAElE;;gEAEgE;AAChE;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;EAC3B,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;gEAEgE;AAChE;EACE,eAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,kEAAkE;AAClE;EACE,mCAAmC;EACnC,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,mCAAmC;EACnC,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,+BAA+B;EAC/B,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA,iEAAiE;AACjE;EACE,gCAAgC;EAChC,+CAA+C;EAC/C,yCAAyC;EACzC,kCAAkC;EAClC,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,oBAAoB;EACpB,yBAAyB;EACzB,qBAAqB;EACrB,kCAAkC;EAClC,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB,qBAAqB,EAAE;;AAE1C;;gEAEgE;AAChE;EACE,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,oBAAoB;EACpB,yBAAyB;EACzB,qBAAqB;EACrB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA,qBAAqB,qBAAqB,EAAE,gBAAgB,EAAE;AAC9D;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,uCAAuC;EACvC,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,kEAAkE;AAClE;EACE,4BAA4B;EAC5B,mCAAmC;EACnC,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,4CAA4C;AAC9C;AACA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4CAA4C;AAC9C;AACA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,2CAA2C;AAC7C;AACA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,2CAA2C;AAC7C;AACA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA,kEAAkE;AAClE;EACE,oBAAoB;EACpB,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,gCAAgC;EAChC,+CAA+C;EAC/C,kCAAkC;EAClC,wBAAwB;EACxB,iDAAiD;AACnD;;AAEA;EACE,wCAAwC;EACxC,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;EACnC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,4BAA4B;EAC5B,gCAAgC;EAChC,6CAA6C;EAC7C,kCAAkC;EAClC,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,kEAAkE;AAClE;EACE,kCAAkC;EAClC,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;AACrB;AACA,gBAAgB,2BAA2B,EAAE,SAAS,EAAE;AACxD,qBAAqB,qBAAqB,EAAE;;AAE5C,uBAAuB,8BAA8B,GAAG,uCAAuC,GAAG;AAClG,uBAAuB,+BAA+B,EAAE,wCAAwC,EAAE;AAClG,uBAAuB,8BAA8B,GAAG,uCAAuC,GAAG;AAClG,uBAAuB,+BAA+B,EAAE,wCAAwC,EAAE;AAClG,uBAAuB,6BAA6B,IAAI,sCAAsC,IAAI;;AAElG;EACE,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,+EAA+E;AAC/E;EACE,8BAA8B;EAC9B,8CAA8C;EAC9C,kCAAkC;EAClC,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,iCAAiC;EACjC,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;;;;;;;;gEAQgE;AAChE,QAAQ,oBAAoB,EAAE;;AAE9B;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,4CAA4C;EAC5C,4BAA4B;EAC5B,kCAAkC;EAClC,qBAAqB;EACrB,yCAAyC;EACzC,gCAAgC;EAChC,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB,SAAS,mCAAmC;EAC5D,gBAAgB,SAAS,qCAAqC;EAC9D,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,kFAAkF;AAClF,eAAe,2BAA2B,EAAE;AAC5C,eAAe,2BAA2B,EAAE;AAC5C,eAAe,2BAA2B,EAAE;;AAE5C,uEAAuE;AACvE;eACe,aAAa,EAAE;;AAE9B,iEAAiE;AACjE;EACE,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,kEAAkE;AAClE;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,mBAAmB;EACnB,8BAA8B;EAC9B,yCAAyC;EACzC,wCAAwC;EACxC,kCAAkC;EAClC,uBAAuB;EACvB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA,kEAAkE;AAClE;EACE,2BAA2B;EAC3B,2DAA2D;EAC3D,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,yCAAyC;EACzC,kCAAkC;EAClC,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA,kEAAkE;AAClE;EACE,qBAAqB;EACrB,yBAAyB;EACzB,uBAAuB;EACvB,qBAAqB;EACrB,kCAAkC;EAClC,oCAAoC;EACpC,uBAAuB;EACvB,iDAAiD;AACnD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,mCAAmC;EACnC,oBAAoB;EACpB,yBAAyB;EACzB,qBAAqB;EACrB,kCAAkC;EAClC,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,+CAA+C;EAC/C,mCAAmC;EACnC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA,qCAAqC,mBAAmB,EAAE;AAC1D,gCAAgC,gCAAgC,EAAE;;AAElE,kEAAkE;AAClE;EACE,2BAA2B;EAC3B,2DAA2D;EAC3D,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,yCAAyC;EACzC,kCAAkC;EAClC,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,uCAAuC;AACzC;;AAEA,2BAA2B,sCAAsC,EAAE;AACnE,2BAA2B,oCAAoC,EAAE;AACjE,2BAA2B,qCAAqC,EAAE;;AAElE;EACE,mCAAmC;EACnC,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA,kEAAkE;AAClE;EACE,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,8BAA8B;EAC9B,yCAAyC;EACzC,kCAAkC;EAClC,wBAAwB;EACxB,qBAAqB;EACrB,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA,gBAAgB,cAAc,EAAE;;AAEhC;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,kEAAkE;AAClE;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;EACvB,iBAAiB;EACjB,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,kEAAkE;AAClE;EACE,6CAA6C;EAC7C,iBAAiB;EACjB,iBAAiB;EACjB,+BAA+B;EAC/B,gCAAgC;EAChC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,kEAAkE;AAClE;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA,kEAAkE;AAClE;EACE,iBAAiB,uBAAuB,EAAE;AAC5C;;AAEA;EACE,kBAAkB,uBAAuB,EAAE;EAC3C,mBAAmB,8BAA8B,EAAE;AACrD;;AAEA;EACE,uBAAuB,eAAe,EAAE;EACxC,uBAAuB,0BAA0B,EAAE;EACnD,uBAAuB,0BAA0B,EAAE;EACnD,mCAAmC,mBAAmB,EAAE;EACxD,mCAAmC,WAAW,EAAE;AAClD","sourcesContent":["/* KinetiQ_UserGuide.css — KinetiQ User Guide\n   v5.0 — restyled to match the live KinetiQ product UI (dark navy / teal,\n   Inter typeface) instead of the earlier light \"Tutorial5\" paper theme.\n   ============================================================ */\n\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=DM+Mono:wght@400;500&display=swap');\n\n/* ─── Design tokens ─────────────────────────────────────────────── */\n:root {\n  --ug-bg:              #0a1526;\n  --ug-surface:         #101f38;\n  --ug-panel:           #14294a;\n  --ug-card:            #101f38;\n  --ug-code-bg:         #0c1830;\n  --ug-eq-bg:           #0c1830;\n\n  --ug-accent:          #17c9a8;\n  --ug-accent-dim:      rgba(23, 201, 168, 0.12);\n  --ug-accent-glow:     rgba(23, 201, 168, 0.25);\n  --ug-accent-hover:    #12a88b;\n\n  --ug-blue:            #5b9dff;\n  --ug-blue-dim:        rgba(91, 157, 255, 0.12);\n  --ug-blue-border:     rgba(91, 157, 255, 0.30);\n\n  --ug-cyan:            #38bdf8;\n  --ug-cyan-dim:        rgba(56, 189, 248, 0.10);\n  --ug-cyan-border:     rgba(56, 189, 248, 0.28);\n\n  --ug-amber:           #f5a524;\n  --ug-amber-dim:       rgba(245, 165, 36, 0.12);\n  --ug-amber-border:    rgba(245, 165, 36, 0.30);\n\n  --ug-red:             #f0453a;\n  --ug-red-dim:         rgba(240, 69, 58, 0.12);\n  --ug-red-border:      rgba(240, 69, 58, 0.35);\n\n  --ug-green-dim:       rgba(23, 201, 168, 0.08);\n  --ug-green-border:    rgba(23, 201, 168, 0.25);\n\n  --ug-border:          #22375c;\n  --ug-border-light:    #1a2c4d;\n  --ug-border-mid:      #2d4979;\n\n  --ug-text:            #eef3fb;\n  --ug-text-muted:      #c1cee3;\n  --ug-text-mid:        #a5b4d1;\n  --ug-text-dim:        #8194b8;\n  --ug-text-sub:        #60729a;\n\n  --ug-font-mono:   'DM Mono', 'JetBrains Mono', monospace;\n  --ug-font-ui:     'Inter', 'Segoe UI', system-ui, sans-serif;\n  --ug-font-brand:  'Inter', system-ui, sans-serif;\n  --ug-font-serif:  'Inter', system-ui, sans-serif; /* kept for compatibility, no longer serif */\n\n  --ug-space-xs:  6px;\n  --ug-space-sm:  10px;\n  --ug-space-md:  16px;\n  --ug-space-lg:  24px;\n  --ug-space-xl:  40px;\n  --ug-space-2xl: 56px;\n\n  --ug-radius-sm: 5px;\n  --ug-radius-md: 9px;\n  --ug-radius-lg: 13px;\n}\n\n/* ─── Reset ─────────────────────────────────────────────────── */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\n/* ─── Scrollbar ─────────────────────────────────────────────── */\n::-webkit-scrollbar        { width: 5px; height: 5px; }\n::-webkit-scrollbar-track  { background: transparent; }\n::-webkit-scrollbar-thumb  { background: var(--ug-border-mid); border-radius: 3px; }\n::-webkit-scrollbar-thumb:hover { background: var(--ug-text-sub); }\n\n/* ══════════════════════════════════════════════════════════════\n   CONTAINER\n══════════════════════════════════════════════════════════════ */\n.ug-container {\n  font-family: var(--ug-font-ui);\n  background:  var(--ug-bg);\n  color:       var(--ug-text);\n  display:     flex;\n  height:      100%;\n  width:       100%;\n  font-size:   15px;\n  line-height: 1.7;\n  overflow:    hidden;\n}\n\n/* ══════════════════════════════════════════════════════════════\n   MAIN CONTENT\n══════════════════════════════════════════════════════════════ */\n.ug-main {\n  flex:       1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  min-width:  0;\n  animation:  fadeInUG 0.3s ease;\n}\n\n.ug-main-inner {\n  margin:  0 auto;\n  padding: 48px 56px 80px;\n  max-width: 1100px;\n}\n\n/* ─── Hero ──────────────────────────────────────────────────── */\n.ug-hero {\n  margin-bottom:  var(--ug-space-2xl);\n  padding-bottom: 32px;\n  border-bottom:  1px solid var(--ug-border-light);\n}\n\n.ug-hero-tag {\n  font-family:    var(--ug-font-mono);\n  font-size:      11px;\n  text-transform: uppercase;\n  letter-spacing: 3px;\n  color:          var(--ug-amber);\n  margin-bottom:  12px;\n}\n\n.ug-hero h1 {\n  font-family:   var(--ug-font-brand);\n  font-size:     38px;\n  font-weight:   800;\n  letter-spacing: -0.5px;\n  line-height:   1.2;\n  margin-bottom: 12px;\n  color:         var(--ug-text);\n}\n\n.ug-hero-desc {\n  color:       var(--ug-text-muted);\n  font-size:   16px;\n  max-width:   660px;\n  line-height: 1.6;\n}\n\n.ug-hero-meta {\n  display:    flex;\n  gap:        24px;\n  margin-top: 20px;\n  flex-wrap:  wrap;\n}\n\n.ug-meta-item {\n  font-family: var(--ug-font-mono);\n  font-size:   11px;\n  color:       var(--ug-text-dim);\n  display:     flex;\n  align-items: center;\n  gap:         6px;\n}\n\n.ug-meta-dot {\n  width:         6px;\n  height:        6px;\n  border-radius: 50%;\n  background:    var(--ug-accent);\n  display:       inline-block;\n}\n\n/* ─── Info table (cover page metadata) ─────────────────────── */\n.ug-info-table {\n  background:    var(--ug-surface);\n  border:        1px solid var(--ug-border-light);\n  border-top:    3px solid var(--ug-accent);\n  border-radius: var(--ug-radius-lg);\n  overflow:      hidden;\n  margin-bottom: var(--ug-space-xl);\n}\n\n.ug-info-table table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.ug-info-table td {\n  padding: 11px 18px;\n  border-bottom: 1px solid var(--ug-border-light);\n  color: var(--ug-text-muted);\n  vertical-align: top;\n}\n\n.ug-info-table td:first-child {\n  font-family:    var(--ug-font-mono);\n  font-size:      11px;\n  text-transform: uppercase;\n  letter-spacing: 1.5px;\n  color:          var(--ug-text-dim);\n  font-weight:    600;\n  width:          180px;\n  white-space:    nowrap;\n  background:     var(--ug-panel);\n}\n\n.ug-info-table tr:last-child td {\n  border-bottom: none;\n}\n\n.ug-info-table a { color: var(--ug-blue); }\n\n/* ══════════════════════════════════════════════════════════════\n   SECTIONS\n══════════════════════════════════════════════════════════════ */\n.ug-section {\n  margin-bottom: var(--ug-space-2xl);\n  scroll-margin-top: 24px;\n}\n\n.ug-section-label {\n  font-family:    var(--ug-font-mono);\n  font-size:      10px;\n  text-transform: uppercase;\n  letter-spacing: 2.5px;\n  color:          var(--ug-text-sub);\n  margin-bottom:  6px;\n}\n\n.ug-section h2 {\n  font-family:   var(--ug-font-brand);\n  font-size:     25px;\n  font-weight:   800;\n  letter-spacing: -0.3px;\n  color:         var(--ug-text);\n  margin-bottom: 6px;\n  line-height:   1.3;\n}\n\n.ug-section-divider {\n  width:         40px;\n  height:        3px;\n  background:    var(--ug-accent);\n  margin-bottom: 22px;\n  border-radius: 2px;\n}\n\n.ug-section p {\n  margin-bottom: 14px;\n  color:         var(--ug-text-muted);\n  line-height:   1.75;\n}\n\n.ug-section strong { color: var(--ug-text); font-weight: 600; }\n.ug-section code {\n  font-family: var(--ug-font-mono);\n  background:  var(--ug-code-bg);\n  border:      1px solid var(--ug-border);\n  padding:     1px 6px;\n  border-radius: 4px;\n  font-size:   0.92em;\n  color:       var(--ug-cyan);\n}\n\n/* ─── Badge / tag ───────────────────────────────────────────── */\n.ug-badge {\n  display:        inline-block;\n  font-family:    var(--ug-font-mono);\n  font-size:      10px;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  padding:        3px 9px;\n  border-radius:  var(--ug-radius-sm);\n  margin-bottom:  10px;\n  font-weight:    500;\n}\n\n.ug-badge--green {\n  background: var(--ug-green-dim);\n  color:      var(--ug-accent);\n  border:     1px solid var(--ug-green-border);\n}\n.ug-badge--amber {\n  background: var(--ug-amber-dim);\n  color:      var(--ug-amber);\n  border:     1px solid var(--ug-amber-border);\n}\n.ug-badge--blue {\n  background: var(--ug-blue-dim);\n  color:      var(--ug-blue);\n  border:     1px solid var(--ug-blue-border);\n}\n.ug-badge--cyan {\n  background: var(--ug-cyan-dim);\n  color:      var(--ug-cyan);\n  border:     1px solid var(--ug-cyan-border);\n}\n.ug-badge--red {\n  background: var(--ug-red-dim);\n  color:      var(--ug-red);\n  border:     1px solid var(--ug-red-border);\n}\n\n/* ─── Steps ─────────────────────────────────────────────────── */\n.ug-steps {\n  display:        flex;\n  flex-direction: column;\n  gap:            18px;\n  margin:         18px 0;\n}\n\n.ug-step {\n  display:       flex;\n  gap:           18px;\n  align-items:   flex-start;\n  background:    var(--ug-surface);\n  border:        1px solid var(--ug-border-light);\n  border-radius: var(--ug-radius-md);\n  padding:       18px 20px;\n  transition:    box-shadow 0.2s, border-color 0.2s;\n}\n\n.ug-step:hover {\n  box-shadow:  0 2px 14px rgba(0,0,0,0.35);\n  border-color: var(--ug-border-mid);\n}\n\n.ug-step-number {\n  font-family:    var(--ug-font-mono);\n  font-size:      13px;\n  font-weight:    600;\n  color:          #06120e;\n  background:     var(--ug-accent);\n  width:          32px;\n  height:         32px;\n  border-radius:  50%;\n  display:        flex;\n  align-items:    center;\n  justify-content:center;\n  flex-shrink:    0;\n  margin-top:     2px;\n}\n\n.ug-step-body {\n  flex: 1;\n  min-width: 0;\n}\n\n.ug-step-title {\n  font-family:   var(--ug-font-brand);\n  font-size:     14.5px;\n  font-weight:   700;\n  color:         var(--ug-text);\n  margin-bottom: 6px;\n  line-height:   1.35;\n  display:       flex;\n  align-items:   center;\n  flex-wrap:     wrap;\n  gap:           4px;\n}\n\n.ug-step-desc {\n  font-size:   13.5px;\n  color:       var(--ug-text-muted);\n  line-height: 1.7;\n  margin:      0;\n}\n\n.ug-step-red-note {\n  display:       inline-flex;\n  align-items:   center;\n  gap:           5px;\n  font-family:   var(--ug-font-mono);\n  font-size:     10px;\n  text-transform:uppercase;\n  letter-spacing:1.5px;\n  color:         var(--ug-red);\n  background:    var(--ug-red-dim);\n  border:        1px solid var(--ug-red-border);\n  border-radius: var(--ug-radius-sm);\n  padding:       2px 8px;\n  margin-left:   8px;\n}\n\n/* ─── Callouts ──────────────────────────────────────────────── */\n.ug-callout {\n  border-radius: var(--ug-radius-md);\n  padding:       14px 18px;\n  margin:        16px 0;\n  font-size:     14px;\n  line-height:   1.65;\n}\n.ug-callout p { color: var(--ug-text-muted); margin: 0; }\n.ug-callout strong { color: var(--ug-text); }\n\n.ug-callout--note    { background: var(--ug-blue-dim);  border: 1px solid var(--ug-blue-border);  }\n.ug-callout--warning { background: var(--ug-amber-dim); border: 1px solid var(--ug-amber-border); }\n.ug-callout--info    { background: var(--ug-cyan-dim);  border: 1px solid var(--ug-cyan-border);  }\n.ug-callout--success { background: var(--ug-green-dim); border: 1px solid var(--ug-green-border); }\n.ug-callout--danger  { background: var(--ug-red-dim);   border: 1px solid var(--ug-red-border);   }\n\n.ug-callout-icon {\n  font-size:     16px;\n  margin-right:  6px;\n  vertical-align: middle;\n}\n\n/* ─── Screenshot placeholder (used only where no real capture exists yet) ── */\n.ug-screenshot {\n  background:    var(--ug-panel);\n  border:        1px dashed var(--ug-border-mid);\n  border-radius: var(--ug-radius-md);\n  padding:       20px;\n  margin:        12px 0;\n  text-align:    center;\n  color:         var(--ug-text-sub);\n  font-family:   var(--ug-font-mono);\n  font-size:     11px;\n  letter-spacing:1px;\n}\n\n.ug-screenshot-icon {\n  font-size:     28px;\n  display:       block;\n  margin-bottom: 6px;\n}\n\n/* ─── Product screenshot frame ───────────────────────────────\n   Every real screenshot sits in this frame.\n   - Images are shown at their ACTUAL pixel size and never stretched\n     (width:auto + max-width), so small captures are no longer\n     up-scaled to the full column width (that caused the blur / zoomed look).\n   - Large captures are shrunk down to a common maximum width so all\n     screenshots read at a similar size and text size.\n   - Frames are centred and shrink-wrap the image.\n   ─────────────────────────────────────────────────────────── */\n:root { --ug-shot-max: 760px; }\n\n.ug-shot {\n  display:       block;\n  width:         fit-content;\n  max-width:     min(100%, var(--ug-shot-max));\n  margin:        14px auto 4px;\n  border-radius: var(--ug-radius-lg);\n  overflow:      hidden;\n  border:        1px solid var(--ug-border);\n  background:    var(--ug-surface);\n  box-shadow:    0 6px 20px rgba(0,0,0,0.35);\n}\n\n.ug-shot img {\n  display:    block;\n  width:      auto;        /* natural size - never up-scaled */\n  max-width:  100%;        /* large images shrink to the frame */\n  height:     auto;\n  margin:     0 auto;\n  image-rendering: auto;\n}\n\n/* Per-figure size presets (use <Shot size=\"sm|md|lg\" /> or <Shot width={px} />) */\n.ug-shot--sm { max-width: min(100%, 420px); }\n.ug-shot--md { max-width: min(100%, 560px); }\n.ug-shot--lg { max-width: min(100%, 760px); }\n\n/* caption strip / red-box dot are no longer used (red boxes removed) */\n.ug-shot-note,\n.ug-shot-dot { display: none; }\n\n/* ─── Sub-section (5.1, 5.2 style) ─────────────────────────── */\n.ug-subsection {\n  margin:        24px 0 18px;\n}\n\n.ug-subsection h3 {\n  font-family:   var(--ug-font-brand);\n  font-size:     18px;\n  font-weight:   700;\n  color:         var(--ug-text);\n  margin-bottom: 8px;\n  line-height:   1.35;\n}\n\n.ug-subsection-divider {\n  width:         24px;\n  height:        2px;\n  background:    var(--ug-blue);\n  margin-bottom: 16px;\n  border-radius: 2px;\n}\n\n/* ─── Reaction formula pill ─────────────────────────────────── */\n.ug-reaction {\n  display:       inline-block;\n  font-family:   var(--ug-font-mono);\n  font-size:     13px;\n  background:    var(--ug-eq-bg);\n  border:        1px solid var(--ug-border);\n  border-left:   3px solid var(--ug-amber);\n  border-radius: var(--ug-radius-md);\n  padding:       8px 16px;\n  color:         var(--ug-text-mid);\n  margin:        10px 0;\n}\n\n/* ─── Contact cards grid ────────────────────────────────────── */\n.ug-contact-grid {\n  display:               grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap:                   16px;\n  margin:                20px 0;\n}\n\n.ug-contact-card {\n  background:    var(--ug-surface);\n  border:        1px solid var(--ug-border);\n  border-radius: var(--ug-radius-md);\n  padding:       18px;\n  transition:    box-shadow 0.2s;\n}\n\n.ug-contact-card:hover {\n  box-shadow: 0 4px 16px rgba(0,0,0,0.35);\n}\n\n.ug-contact-card-icon {\n  font-size:     24px;\n  margin-bottom: 10px;\n  display:       block;\n}\n\n.ug-contact-card-title {\n  font-family:    var(--ug-font-mono);\n  font-size:      10px;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  color:          var(--ug-accent);\n  margin-bottom:  6px;\n  font-weight:    600;\n}\n\n.ug-contact-card-body {\n  font-size:   13px;\n  color:       var(--ug-text-muted);\n  line-height: 1.6;\n}\n\n/* ─── Troubleshooting table ─────────────────────────────────── */\n.ug-trouble-table {\n  width:           100%;\n  border-collapse: collapse;\n  margin:          16px 0;\n  font-size:       13px;\n  background:      var(--ug-surface);\n  border-radius:   var(--ug-radius-md);\n  overflow:        hidden;\n  border:          1px solid var(--ug-border-light);\n}\n\n.ug-trouble-table thead {\n  background: var(--ug-panel);\n}\n\n.ug-trouble-table th {\n  padding:        11px 14px;\n  text-align:     left;\n  font-family:    var(--ug-font-mono);\n  font-size:      10px;\n  text-transform: uppercase;\n  letter-spacing: 1.5px;\n  color:          var(--ug-text-dim);\n  border-bottom:  1px solid var(--ug-border);\n  font-weight:    600;\n}\n\n.ug-trouble-table td {\n  padding:       12px 14px;\n  border-bottom: 1px solid var(--ug-border-light);\n  color:         var(--ug-text-muted);\n  vertical-align: top;\n  line-height:   1.6;\n}\n\n.ug-trouble-table td:first-child {\n  font-weight: 600;\n  color:       var(--ug-text);\n  white-space: nowrap;\n}\n\n.ug-trouble-table tr:last-child td { border-bottom: none; }\n.ug-trouble-table tr:hover td { background: var(--ug-accent-dim); }\n\n/* ─── Tutorial cards ────────────────────────────────────────── */\n.ug-tutorial-cards {\n  display:               grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap:                   18px;\n  margin:                20px 0;\n}\n\n.ug-tutorial-card {\n  background:    var(--ug-surface);\n  border:        1px solid var(--ug-border);\n  border-radius: var(--ug-radius-md);\n  padding:       20px;\n  transition:    all 0.2s ease;\n}\n\n.ug-tutorial-card:hover {\n  transform:  translateY(-3px);\n  box-shadow: 0 10px 24px rgba(0,0,0,0.4);\n}\n\n.ug-tutorial-card--cre   { border-top: 3px solid var(--ug-accent); }\n.ug-tutorial-card--fit   { border-top: 3px solid var(--ug-blue); }\n.ug-tutorial-card--react { border-top: 3px solid var(--ug-amber); }\n\n.ug-tutorial-card-title {\n  font-family:   var(--ug-font-brand);\n  font-size:     15px;\n  font-weight:   700;\n  color:         var(--ug-text);\n  margin-bottom: 8px;\n}\n\n.ug-tutorial-card-desc {\n  font-size:   13px;\n  color:       var(--ug-text-dim);\n  line-height: 1.65;\n  margin:      0 0 12px;\n}\n\n.ug-tutorial-card-tag {\n  font-family:    var(--ug-font-mono);\n  font-size:      9px;\n  text-transform: uppercase;\n  letter-spacing: 1.5px;\n  padding:        2px 8px;\n  border-radius:  var(--ug-radius-sm);\n  font-weight:    500;\n}\n\n/* ─── Platform URL bar ──────────────────────────────────────── */\n.ug-url-bar {\n  display:       flex;\n  align-items:   center;\n  gap:           10px;\n  background:    var(--ug-eq-bg);\n  border:        1px solid var(--ug-border);\n  border-radius: var(--ug-radius-md);\n  padding:       10px 16px;\n  margin:        12px 0;\n  font-family:   var(--ug-font-mono);\n  font-size:     12px;\n  color:         var(--ug-blue);\n}\n\n.ug-url-bar a { color: inherit; }\n\n.ug-url-label {\n  color:       var(--ug-text-sub);\n  font-size:   10px;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  flex-shrink: 0;\n}\n\n/* ─── Bullet list ───────────────────────────────────────────── */\n.ug-list {\n  list-style:  none;\n  padding:     0;\n  margin:      12px 0;\n}\n\n.ug-list li {\n  display:     flex;\n  gap:         10px;\n  align-items: flex-start;\n  font-size:   14px;\n  color:       var(--ug-text-muted);\n  line-height: 1.7;\n  padding:     4px 0;\n}\n\n.ug-list li::before {\n  content:     '•';\n  color:       var(--ug-accent);\n  font-size:   18px;\n  line-height: 1.3;\n  flex-shrink: 0;\n}\n\n/* ─── Footer ────────────────────────────────────────────────── */\n.ug-footer {\n  border-top:  1px solid var(--ug-border-light);\n  padding-top: 24px;\n  margin-top:  40px;\n  color:       var(--ug-text-dim);\n  font-family: var(--ug-font-mono);\n  font-size:   11px;\n  text-align:  center;\n}\n\n/* ─── Animation ─────────────────────────────────────────────── */\n@keyframes fadeInUG {\n  from { opacity: 0; transform: translateY(4px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n/* ─── Responsive ────────────────────────────────────────────── */\n@media (max-width: 1200px) {\n  .ug-main-inner { padding: 36px 36px 60px; }\n}\n\n@media (max-width: 900px) {\n  .ug-main-inner  { padding: 24px 20px 60px; }\n  .ug-contact-grid { grid-template-columns: 1fr 1fr; }\n}\n\n@media (max-width: 600px) {\n  .ug-hero h1          { font-size: 26px; }\n  .ug-contact-grid     { grid-template-columns: 1fr; }\n  .ug-tutorial-cards   { grid-template-columns: 1fr; }\n  .ug-trouble-table td:first-child { white-space: normal; }\n  .ug-info-table td:first-child    { width: auto; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
